import { gql } from '@apollo/client';

export const CREATE_HSL_AUTHENTICATION = gql`
  mutation CreateHslAuthentication($input: CreateHslAuthenticationInput!) {
    createHslAuthentication(input: $input) {
      accountId
    }
  }
`;
